import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { PARTNER_PROJECTS_GET2 } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_projects2 = ({fat}) => {
    return (dispatch, getState) => {

        return Auth.currentSession().then((session) => {

        const token = session && session.idToken.jwtToken;

        var config = { headers: { Authorization: 'Bearer ' + token } };

        if (!fat)
            fat = false;

        return axios.get(`${Config.API_BASE_URL}/partner/projects2?f=${fat}`, config)
            .then(response => {
                dispatch({
                    type: PARTNER_PROJECTS_GET2,
                    payload: {
                        projects: response.data,
                        errors: {},
                        task: {
                            result: true
                        }
                    }
                })

                let payload = {
                    projects: response.data,
                    errors: {},
                    task: {
                        result: true
                    }
                }

                return payload;
            })
            .catch(error => {
                dispatch({
                    type: PARTNER_PROJECTS_GET2,
                    payload: {
                        errors: {},
                        task: {
                            result: false
                        }
                    }
                })
            });
}).catch(error => {
 dispatch({ type: EXPIRED });
 });
 };
}

export default api_get_projects2;
